export const enum VolleyballKeyPeriod {
  FINISHED = 'finished',
  TIMEOUT = 'timeout',
  PERIOD = 'period',
}
